(function () {
    'use strict';

    angular.module('swif.achats')
    .config(routeConfig)
    .factory('ConsumableStockService', ConsumableStockService)
    .controller('ConsumablesStockController', ConsumablesStockController)
    .controller('ConsumablesMovesController', ConsumablesMovesController)
    .controller('ConsumablesInventoryController', ConsumablesInventoryController)
    .controller('ConsumableStockMoveInController', ConsumableStockMoveInController)
    .controller('ConsumableCatalogController', ConsumableCatalogController);

    function routeConfig($routeProvider) {
        $routeProvider.when('/achats-stocks/consumables/table_view', {
            templateUrl: 'partials/achats/consumables_table_view.html',
            controller: 'ConsumablesStockController',
            resolve: {
                data: ['ConsumableStockService', function (service) {
                    return service.resolveConsumablesData();
                }]
            },
            reloadOnSearch: false
        });

        $routeProvider.when('/achats-stocks/consumable_moves/table_view', {
            templateUrl: 'partials/achats/consumables_moves_table_view.html',
            controller: 'ConsumablesMovesController',
            resolve: {
                data: ['ConsumableStockService', function (service) {
                    return service.resolveMovesData();
                }]
            },
            reloadOnSearch: false
        });

        $routeProvider.when('/achats-stocks/inventory/table_view', {
            templateUrl: 'partials/achats/inventory_table_view.html',
            controller: 'ConsumablesInventoryController',
            resolve: {
                data: ['ConsumableStockService', function (service) {
                    return service.resolveInventoryData();
                }]
            },
            reloadOnSearch: false
        });
    }

    ConsumableStockService.$inject = ['$q', 'swifFrameworkService', 'AchatsService', 'swifOpenbaseConsumableService'];
    function ConsumableStockService($q, swif, achats, consumableSrv) {
        var service = {};

        service.COLLECTION_ID = 'consumables';
        service.getCollection = function () {
            return swif.collection.getCollection(service.COLLECTION_ID);
        };

        service.createConsumablesCollection = function () {
            var user = swif.user.getAuthenticatedUserData();
            var filter = {};
            let userWareHouseIds = user.warehouse_ids || [];
            filter.context = { warehouse_ids: userWareHouseIds } // filters on product quantities
            swif.data.sortOn(filter, 'id', 'DESC');
            swif.data.addExtraFilter(filter, 'stock', 'type_prod', '=', 'fourniture');
            swif.data.addExtraFilter(filter, 'wharehouses', 'warehouse_product_present_ids', '=', userWareHouseIds);
            if (_.contains(user.access_rights, 'ACHATS_CLAIMER') || _.contains(user.access_rights, 'ACHATS_AGENT')) {
                swif.data.addExtraFilter(filter, 'stock', 'type_id.service_ids', 'in', [user.service_id[0]]);
            }
            return swif.collections.createOrUpdate(
                service.COLLECTION_ID,
                'consumable_stock',
                filter,
                {location: true}
            );
        };

        service.MOVES_COLLECTION_FIELDS = [
            'actions', 'address_id', 'attachment_count', 'auto_validate', 'backorder_id',
            'claimer_id', 'company_id', 'create_date', 'date', 'date_expected',
            'direct_picking_line_id', 'id', 'location_dest_id', 'location_id',
            'mail_message_count', 'merge_ask_id', 'move_dest_id', 'move_history_ids',
            'move_history_ids2', 'move_type', 'name', 'note', 'origin', 'partner_id', 'picking_id',
            'price_currency_id', 'price_unit', 'priority', 'procurements', 'prodlot_id',
            'product_id', 'consumable_type_id', 'product_packaging', 'product_qty', 'product_uom', 'product_uos',
            'product_uos_qty', 'purchase_line_id', 'sale_line_id', 'scrapped', 'service_id',
            'state', 'tracking_id', 'warehouse_id', 'price_unit', 'default_price', 'pump', 'stock_value'
        ];

        service.MOVES_COLLECTION_ID = 'moves';
        service.getMovesCollection = function () {
            return swif.collection.getCollection(service.MOVES_COLLECTION_ID);
        };

        service.createMovesCollection = function () {
            var user = swif.user.getAuthenticatedUserData();
            var filter = {}; // type_prod = "material" || "furniture"
            filter.fields = service.MOVES_COLLECTION_FIELDS;
            swif.data.sortOn(filter, 'date', 'DESC');
            swif.data.addExtraFilter(filter, 'stock', '|');
            swif.data.addExtraFilter(filter, 'stock', 'product_id.type_prod', '=', 'material');
            swif.data.addExtraFilter(filter, 'stock', 'product_id.type_prod', '=', 'fourniture');
            swif.data.addExtraFilter(filter, 'stock', 'state', '=', 'done');
            if (_.contains(user.access_rights, 'ACHATS_CLAIMER') || _.contains(user.access_rights, 'ACHATS_AGENT')) {
                swif.data.addExtraFilter(filter, 'stock', 'consumable_type_id.service_ids', 'in', [user.service_id[0]]);
            }
            return swif.collections.createOrUpdate(
                service.MOVES_COLLECTION_ID,
                'stock_move',
                filter,
                {location: true}
            );
        };

        service.INVENTORY_COLLECTION_ID = 'inventory';
        service.getInventoryCollection = function () {
            return swif.collection.getCollection(service.INVENTORY_COLLECTION_ID);
        };

        service.createInventoryCollection = function () {
            var user = swif.user.getAuthenticatedUserData();
            var filter = {};
            let userWareHouseIds = user.warehouse_ids || [];
            filter.context = { is_view: true, authorized_warehouse_ids: userWareHouseIds }; // filters on product quantities
            swif.data.sortOn(filter, 'warehouse_id', 'DESC');
            return swif.collections.createOrUpdate(
                service.INVENTORY_COLLECTION_ID,
                'inventory',
                filter,
                {limitPerPage: 50}
            );
        };

        service.prepareNewMoves = function (model) {
            _.forEach(model.moves, function (move) {
                if (!move.product && move.product_id) {
                    // useful when editing existing consumable-requests
                    // on 'move_in' or 'move_out', may not enter in this block
                    move.product = {
                        id: move.product_id[0],
                        name: move.product_id[1],
                        product_id: move.product_id,
                        asks: []
                    };
                }
                if (!move._asked_qty) {
                    move._asked_qty = 0;
                }
                if (!move._qty_available) {
                    move._qty_available = 0;
                }
            });
        };

        // @param product: (object) product to use to create move
        service.prepareMoveFromProduct = function (product, model) {

            product.qty_available_by_location = model.cache[product.id];
            /* Get price from consumable */
            var consumable = {};
            if (model.items){
                model.items.map((item) => {
                    if(item.product_id[0] == product.id){
                        consumable = item;
                    }
                });
            }
            return {
                product: product,
                product_id: [product.id, product.complete_name || product.name],
                product_qty: 1,
                price: consumable.price,
                warehouse_id: model.warehouse_id,
                _qty_available: 0,
                _asked_qty: 0
            };
        };

        let setConsumableData = function(model, move, record){
            move.price = record.price
            var user = swif.user.getAuthenticatedUserData();
            if (user.warehouse_ids.indexOf(record.default_warehouse_id[0]) != -1
                && !model.warehouse_id) {
                move.warehouse_id = record.default_warehouse_id;
            }
        }

        let consumableFilter = function(consumableIds){
            let filter = {};
            filter.limit = 0;
            filter.fields = ['price', 'default_warehouse_id', 'product_id'];
            swif.data.addFilter(filter, '|')
            // if model received = consumable type
            swif.data.addFilter(filter, 'id', 'in', consumableIds);
            // if model received = product type
            swif.data.addFilter(filter, 'product_id', 'in', consumableIds);
        }

        let getConsumableData = function (model, consumableIds){
            // getting all necessary data like warehouse_id  and quantity from consumable with product data
            let filter = consumableFilter(consumableIds)
            swif.data.searchRead('consumable', filter).then(function (products) {
                if (!_.isEmpty(products)) {
                    _.forEach(model.moves, function (move) {
                        _.forEach(products.records, function (record) {
                            if (move.product_id[0]===record.id){
                                setConsumableData(model, move, record)
                            } else if (record.product_id.length !==0 ) {
                                if(move.product_id[0] === record.product_id[0]) {
                                    setConsumableData(model, move, record)
                                }
                            }
                    })
                });
                }
            });
        }

        // fetch qty_available_by_location and store values to the cache
        // when new products are added to mode.moves, will only fetch non-cached products
        // model.cache => {prod_id: {qty_available_by_location: 0, asks: []}}
        service.fetchQtyByLocation = function (model) {
            var defer = $q.defer();
            var promise = defer.promise;
            var todo = [];
            var consumableIds = [];
            var moveByProd = {};
            _.forEach(model.moves, function (move) {
                var prodId = 0;
                if (move.product.product_id) {
                    prodId = move.product.product_id[0];
                } else {
                    prodId = move.product_id[0];
                }
                if (prodId) {
                    if (!model.cache[prodId]) {
                        todo.push(prodId);
                        consumableIds.push(move.product_id[0]);
                        moveByProd[prodId] = move;
                    }
                }
            });
            if (todo.length > 0) {
                var filter = {fields: ['qty_available_by_location']};
                promise = swif.data.get('product', todo, filter)
                .then(function (data) {
                    // TOCHECK: always useful ? check get(), data framework
                    if (!_.isArray(data)) {
                        data = [data];
                    }
                    _.forEach(data, function (item) {
                        model.cache[item.id] = item.qty_available_by_location;
                        if (moveByProd[item.id]) {
                            moveByProd[item.id].product.qty_available_by_location = item.qty_available_by_location;
                        }
                    });
                    // TG3825 - Stock price to be loaded when new entry of stock
                    getConsumableData(model, consumableIds);
                    return model.cache;
                });
            } else {
                defer.resolve();
            }
            return promise;
        };

        // according to model.warehouse_id, attach the qty from this warehouse
        // if model.warehouse_id is not set, sum qties from ALL warehouses
        service._computeQtyAvailable = function (model, item) {
            // if set, sum only data on the warehouse ID,
            // otherwise, will sum data of the whole array
            var compare = false;
            var val = {total: 0};
            _.forEach(item.product.qty_available_by_location, function (loc) {
                if (!val[loc.warehouse_id]) {
                    val[loc.warehouse_id] = {qty: 0, name: loc.warehouse};
                }
                val[loc.warehouse_id].qty += loc.qty;
                val.total += loc.qty;
            });
            item._qty_available = val;
        };

        // merge all asks by service
        service._computeAskedQty = function (model, item) {
            var compare = false;
            if (model.service_id) {
                compare = model.service_id[0];
            }
            var val = {total: 0, lines: {}};
            // browse asks on product and filter them with service_id
            _.forEach(item.product.asks, function (ask) {
                var srvId = ask.service_id ? ask.service_id[0]: false;
                if (srvId === compare || !compare) {
                    if (!val.lines[srvId]) {
                        val.lines[srvId] = {qty: 0, name: ask.service_id[1]};
                    }
                    val.lines[srvId].qty += ask.qty;
                    val.total += ask.qty;
                }
            });
            item._asked_qty = val;
        };

        // call it everytime you need to sanitze your data
        service.parseMoves = function (model) {
            _.forEach(model.moves, function (item) {
                service._computeQtyAvailable(model, item);
                service._computeAskedQty(model, item);
            });
            model.hasMove = model.moves.length > 0 ? true: undefined;
        };

        // call it everytime a new move is added
        service.parseNewMoves = function (model) {
            service.prepareNewMoves(model);
            var userIs = achats.rights.getPermissions();
            if (userIs.consumable_request.manager) {
                return service.fetchQtyByLocation(model)
                .then(function () {
                    service.parseMoves(model);
                    return true;
                });
            }
        };

        service.addMove = function (model, item) {
            model.moves.push(item);
            service.parseNewMoves(model);
        };

        service.removeMove = function (model, item) {
            _.remove(model.moves, item);
            service.parseMoves(model);
        };

        service.initializeFromConsumables = function (model) {
        return achats.product.fetchFromConsumablesCart(['asks'])
            .then(function (products) {
                _.forEach(products, function (product) {
                    var move = service.prepareMoveFromProduct(product, model);
                    // ensure the product is not yet present in the other moves
                    var existing = _.find(model.moves, function (elt) {
                        return elt.product_id[0] === move.product_id[0];
                    });
                    if (!existing) {
                        // do not use addMove() for performances purpose,
                        // the call of parseMoves() will sanitize the data
                        model.moves.push(move);
                    }
                });
                return service.parseNewMoves(model);
            });
        };

        service.createConsumableMoveLines = function(data){
            if(data.model.consumables){
                var consumables = data.model.consumables;
                var user = swif.user.getAuthenticatedUserData();
                var userContext = swif.user.getAuthenticatedUser().context;

                consumables.forEach(function(consumable){
                    if((!consumable.isAskedConsumable && consumable.stocked && consumable.warehouse_id.length > 0) || !consumable.stocked){
                        if (!consumable.stocked){
                            consumable.warehouse_id = [1]
                        }
                        var vals = {
                            ask_prod_id: undefined,
                            move_type: "out",
                            warehouse_id: consumable.warehouse_id,
                            service_id: user.service_id,
                            user_id: [ user.id, user.login],
                            origin: consumable.purchase_order_name || '',
                        };
                        var fake_model = {
                            cache: {},
                            moves: []
                        };
                        var productFilter = {};
                        swif.data.addFilter(productFilter, 'id', '=',consumable.product_id);
                        swif.data.get('product', undefined, productFilter).then(function (products) {

                            // Get products related to lines and prepare moves
                            products.forEach(function(product){
                                var move = service.prepareMoveFromProduct(product, fake_model);
                                move.product_qty = consumable.quantity;
                                // move.origin = consumable.purchase_order_name;
                                fake_model.moves.push(move);
                            });

                            return fake_model;
                        }).then(function(fake_model){

                            // Prepare stock_direct_picking_lines
                            vals.ask_lines = swif.data.prepareOne2manyValues(
                                vals.ask_lines || [],
                                fake_model['moves'],
                                function (elt) {
                                    return {
                                        product_id: elt.product_id ? elt.product_id[0]: false,
                                        product_qty: elt.product_qty || 0,
                                        price_unit: elt.price_unit || 0,
                                        warehouse_id: elt.warehouse_id,
                                    };
                                }
                            );

                            userContext['origin'] = consumable.purchase_order_name;

                            swif.data.create('stock_direct_picking', vals).then(function (data) {

                                var resId = data.result || data.result.data || data.result.result;

                                return swif.data.callKw(
                                    'stock_direct_picking',
                                    'perform_all_moves',
                                    [[resId]],
                                    {
                                        context: userContext
                                    });
                            });
                        });
                    }
                });
            }
        };

        service.saveMoves= function (model) {

            var vals = {
                service_id: model.service_id,
                user_id: model.user_id,
                move_type: model.move_type,
                ask_prod_id: model.ask_prod_id || false
            };

            var product_qtys = {};

            model.moves.map(move => {
                product_qtys[move.product_id[0]] = move.price;
            });

            vals.ask_lines = swif.data.prepareOne2manyValues(
                vals.ask_lines || [],
                model.moves,
                function (elt) {
                    return {
                        product_id: elt.product_id ? elt.product_id[0]: false,
                        product_qty: elt.product_qty || 0,
                        price_unit: elt.price,
                        warehouse_id: elt.warehouse_id && elt.warehouse_id[0]
                    };
                }
            );

            function createStockMove(vals) {
                return swif.data.create('stock_direct_picking', vals)
                    .then(function (data) {
                        var resId = data.result || data.result.data || data.result.result;
                        return swif.data.callKw(
                            'stock_direct_picking',
                            'perform_all_moves',
                            [[resId], product_qtys],
                            { context: userContext }
                        );
                    });
            }

            var userContext = swif.user.getAuthenticatedUser().context;

            if (model.task_id && model.service_id) {
                let filter = {};
                swif.data.addFilter(filter, 'id', '=', model.task_id[0]);
                return swif.data.get('task', undefined, filter).then(task => {
                    task = task[0];
                    if (task.consumable_asks.length == 0) {
                        var askProd = {
                            service_id: model.service_id,
                            task_id: model.task_id,
                            state: 'in_progress'
                        };
                        return swif.data.create('openstc_ask_prod', askProd).then(res => {
                            vals.ask_prod_id = [res.result, task.name];
                            return createStockMove(vals);
                        });
                    } else {
                        return createStockMove(vals);
                    }
                });
            } else {
                return createStockMove(vals);
            }
        };

        service.prepareAskForSave = function (model) {
            var m2o = achats.formatters.m2o;
            var vals = {
                name: model.name || '',
                service_id: model.service_id,
                user_id: model.user_id
            };
            vals.merge_line_ask_id = swif.data.prepareOne2manyValues(
                vals.merge_line_ask_id || [],
                model.merge_line_asks,
                function (elt) {
                    return {
                        product_id: m2o(elt.product_id),
                        product_qty: elt.product_qty || 0,
                        service_id: m2o(model.service_id),
                        warehouse_id: elt.warehouse_id
                    };
                }
            );
            return vals;
        }

        service.saveAsk = function (model) {
            var vals = service.prepareAskForSave(model);
            return swif.data.create('openstc_ask_prod', vals);
        };

        service.preMoveModal = function (data){
            if (_.contains(['move_in', 'move_out'], data.action.id)) {
                delete data.model.id;
                data.model.cache = {};
                data.model.moves = [];
                data.model.move_type = data.action.id === 'move_out' ? 'out': 'in';
                // initialize data from consumables on the cart
                service.initializeFromConsumables(data.model);
            }
        };

        service.preInventoryModal = function (data){
            if (_.contains(['move_in', 'move_out'], data.action.id)) {
                data.model.cache = {};
                data.model.moves = [];
                data.model.warehouse_id = [data.model.warehouse_id, data.model.warehouse_name];
                if (data.model.product_id) { // Is a line
                    data.model.moves.push({
                        product: {
                            product_id: [data.model.product_id, data.model.product_name]
                        },
                        product_id: [data.model.product_id, data.model.product_name],
                        product_qty: 1,
                        price: 0,
                        warehouse_id: data.model.warehouse_id,
                        _qty_available: {warehouse_id: {qty: data.model.qty, name: data.model.warehouse_name}},
                        _asked_qty: 0
                    });
                    data.model.hasMove = true;
                }
                data.model.move_type = data.action.id === 'move_out' ? 'out': 'in';
            }
        };

         service.preModal = function (data) {
            var ret = service.getCollection().preModal(data);
            if(data.action.id === 'add') {
                delete data.model.id;
                data.model._type = 'consumable_stock';
                data.model.lines = [];
                // assumes user wants to create stockable consumable
                data.model.is_stock = true;
            } else if (_.contains(['move_in', 'move_out'], data.action.id)) {
                service.preMoveModal(data);
            } else if (data.action.id === 'make_ask') {
                delete data.model.id;
            }
            return ret;
        };

        service.preValidate = function (data) {
            function onSuccess () {
                return true;
            }
            var ret;
            switch (data.action.id)  {
                case 'add':
                    ret = consumableSrv.create(data.model);
                    break;
                case 'edit':
                    ret = true;
                    break;
                case 'move_in':
                    ret = service.saveMoves(data.model);
                    break;
                case 'move_out':
                    ret = service.saveMoves(data.model);
                    break;
                case 'make_ask':
                    ret = service.saveAsk(data.model);
                    break;
                case 'catalog':
                    ret = true;
                    swif.cart.emptyCart('consumable_stock');
                    var consumables = _.where(data.model.catalog.cache, {selected: true});
                    _.forEach(consumables, function (consumable) {
                        swif.cart.addToCart(consumable);
                    });
                    break;
                default:
                    ret = service.getCollection().preValidate(data);
            }
            return ret;
        };

        service.moveCallBack = function(error, data){
            if (_.contains(['move_in', 'move_out'], data.action.id)) {
                service.getMovesCollection().getItems();
                achats.product.emptyConsumablesCart();
            }
        };

        service.inventoryCallback = function(error, data){
            if (_.contains(['move_in', 'move_out'], data.action.id)) {
                service.getInventoryCollection().getItems();
            }
        };

        service.callback = function (error, data) {
            // when removing consumable from stock (is_stock is false),
            // fetch all data to remove it from table
            if (data.action.id === 'add' || data.action.id === 'edit' && !data.model.is_stock) {
                // TODO: could not use fasterCallback (for now),
                // data.result is not defiend here (perharps because modal.http is not defined)
                service.getCollection().getItems();
                swif.collection.defaultCallbackMessage(error, data);
            } else if (_.contains(swif.collection.defaultActionIds, data.action.id)) {
                service.getCollection().fasterCallback(data);
            } else if (_.contains(['move_in', 'move_out'], data.action.id)) {
                service.getCollection().getItems();
                achats.product.emptyConsumablesCart();
            } else if (_.contains(['catalog', 'export', 'export_collection'], data.action.id)) {
                return;
            } else {
                service.getCollection().updateItem(data.model);
            }
        };

        service.resolveConsumablesData = function () {
            var ret = $q.defer();
            swif.route.check().then(function () {
                var defers = [];
                defers.push(service.createConsumablesCollection());
                $q.all(defers).then(function (res) {
                    var data = {consumables: res[0]};
                    ret.resolve(data);
                });
            });
            return ret.promise;
        };

        service.resolveMovesData = function () {
            var ret = $q.defer();
            swif.route.check().then(function () {
                var defers = [];
                defers.push(service.createMovesCollection());
                $q.all(defers).then(function (res) {
                    var data = {moves: res[0]};
                    ret.resolve(data);
                });
            });
            return ret.promise;
        };

        service.resolveInventoryData = function () {
            var ret = $q.defer();
            swif.route.check().then(function () {
                var defers = [];
                defers.push(service.createInventoryCollection());
                $q.all(defers).then(function (res) {
                    var data = {inventory: res[0]};
                    ret.resolve(data);
                });
            });
            return ret.promise;
        };

        service.getFilters = function (picking) {
            var ret = {
                product_id: {fields: ['name', 'complete_name', 'state', 'default_code', 'asks', 'default_warehouse_id']},
                warehouse_id: {},
                user: {},
                consumable: {fields: ['name', 'complete_name', 'state', 'product_id']}
            };
            var user = swif.user.getAuthenticatedUserData();
            var userServiceIds = user.service_ids;
            var srv = picking.service_id ? picking.service_id[0]: 0;
            // var consumableSrv = picking.service_id ? picking.service_id[0] : user.service_id[0]
            swif.data.addFilter(ret.user, 'service_ids', '=', srv);
            swif.data.addFilter(ret.consumable, '|');
            swif.data.addFilter(ret.consumable, 'type_id.service_ids', '=', false);
            swif.data.addFilter(ret.consumable, 'type_id.service_ids', 'in', userServiceIds);
            achats.filters.getProductFilter(ret.product_id, user.service_ids);
            achats.filters.getWarehouseFilter(ret.warehouse_id);
            return ret;
        };

        service.getCountFilter = function () {
            var ret = {info: {}, warning: {}};
            // warning: for one2many (and many2many) domain on _inherits models,
            // we must prefix it with the inheritance field (here: 'product_id')
            // (ask_lines is on product model, not in consumable model)
            swif.data.addFilter(ret.info, 'product_id.ask_lines.qty_remaining', '>', 0);
            swif.data.addFilter(ret.warning, 'state', 'in', ['expired', 'critical']);
            return ret;
        };

        service.getProductFilter = function () {
            var ret = {fields:['name', 'qty_available_by_location', 'default_warehouse_id',]};
            return ret;
        };
        return service;

        $scope.$watch('$ctrl.searchFilter.consumable_ids',
        function (newV, oldV) {
            if (!_.isEmpty(newV)) {
                getMovesForTable();
            } else if (!_.isEmpty(oldV) && _.isUndefined(newV)){
                //user have delete the last consumable
                getMovesForTable();
            }
        });

    }

    ConsumablesMovesController.$inject = ['$scope', 'ConsumableStockService', 'data'];
    function ConsumablesMovesController ($scope, service, data) {
        console.log("Init ConsumablesMovesController")
        $scope.moves = data.moves;
        $scope.preModal = service.preMoveModal;
        $scope.preValidate = service.preValidate;
        $scope.callback = service.moveCallBack;
        $scope.onLoadPrice = function (item) {
            if (item.price_unit == 0){
                item.price_unit = item.default_price
            }
            return item.price_unit
        };
    }

    ConsumablesInventoryController.$inject = ['$scope', 'ConsumableStockService', 'data'];
    function ConsumablesInventoryController ($scope, service, data) {
        console.log('Init ConsumablesInventoryController')
        $scope.inventory = data.inventory;
        $scope.preModal = service.preInventoryModal;
        $scope.preValidate = service.preValidate;
        $scope.callback = service.inventoryCallback;
    }

    ConsumablesStockController.$inject = ['$scope', 'swifFrameworkService', 'ConsumableStockService', 'data'];
    function ConsumablesStockController ($scope, swif, service, data) {
        console.log('Init ConsumablesStockController')
        $scope.consumables = data.consumables;
        $scope.preModal = service.preModal;
        $scope.preValidate = service.preValidate;
        $scope.callback = service.callback;
        $scope.countFilter = service.getCountFilter();
        $scope.productFilter = service.getProductFilter();
        $scope.cart = swif.cart;

        function getQuotationLink() {
            var ret = '';
            var actionView = swif.action.getActionById('quotation', 'views', 'table', {});
            if (actionView) {
                ret = '#' + actionView.link + '?doAction=list.add';
            }
            return ret;
        }

        function getPurchaseLink() {
            var ret = '';
            var actionView = swif.action.getActionById('purchase_order', 'views', 'table', {});
            if (actionView) {
                ret = '#' + actionView.link + '?doAction=list.add';
            }
            return ret;
        }

        function getRequestLink () {
            var ret = '';
            var actionView = swif.action.getActionById('openstc_ask_prod', 'views', 'request', {});
            if (actionView) {
                ret = '#' + actionView.link + '?doAction=list.add';
            }
            return ret;
        }

        $scope.quotationLink = getQuotationLink();
        $scope.purchaseLink = getPurchaseLink();
        $scope.requestLink = getRequestLink();
    }

    ConsumableStockMoveInController.$inject = ['$scope', '$q', '$sce', 'swifFrameworkService', 'ConsumableStockService', 'AchatsService'];
    function ConsumableStockMoveInController($scope, $q, $sce, swif, service, achats) {
        console.log('Init ConsumableStockMoveInController')
        $scope.modules = swif.settings.app.modules;

        function initialize () {
            $scope.filters = service.getFilters($scope.model);
            $scope.fakes = {
                product_id: false
            };
            $scope.is = achats.rights.getPermissions();
        }
        initialize();


        $scope.onChangeFakeProduct = function (product){
            var user = swif.user.getAuthenticatedUserData();

            if (product.id) {
                var found = _.find($scope.model.moves, function (elt) {
                    return product.product_id[0] === elt.product_id[0]
                });
                if (found) {
                    found.product_qty += 1.0;
                } else {
                    var newItem = service.prepareMoveFromProduct(product, $scope.model);
                    // Permit to choose the default warehouse if the user is manager
                    if (user.warehouse_ids.indexOf(product.default_warehouse_id[0]) !== -1){
                        newItem.warehouse_id = product.default_warehouse_id;
                    }

                    newItem.product_id = product.product_id;
                    service.addMove($scope.model, newItem);
                }
                $scope.fakes.product_id = false;
            }
        };

        $scope.formatTasksNames = function(item) {
            var taskLabel = `<span class="label task-id-label">T.${item.id}</span>&nbsp;&nbsp;`;
            var itemName = taskLabel + item.name;
            return $sce.trustAsHtml(itemName);
        }

        $scope.loadConsumablesForTask = function(taskId) {

            let taskFilter = { fields: ['name', 'consumable_asks', 'service_id', 'team_id', 'user_id'] };
            swif.data.addFilter(taskFilter, 'id', '=', taskId);
            swif.data.get('task', undefined, taskFilter).then(function (data) {
                if (!_.isEmpty(data)) {
                    var task = data[0];
                    $scope.model.service_id = task.service_id;
                    $scope.model.task_id = [task.id, task.name];
                    if (task.user_id) {
                        $scope.model.user_id = task.user_id;
                    } else if (task.team_id) {
                        // Get team manager
                        var filter = {};
                        swif.data.addFilter(filter, 'id', '=', task.team_id[0]);
                        swif.data.get('team', undefined, filter).then(team => {
                            $scope.model.user_id = team[0].manager_id;
                        });
                    } else {
                        // Get service manager
                        var filter = {};
                        swif.data.addFilter(filter, 'id', '=', task.service_id[0]);
                        swif.data.get('department', undefined, filter).then(service => {
                            $scope.model.user_id = service[0].manager_id;
                        });
                    }

                    // If task has consumable request products, add them to the move
                    if (task.consumable_asks.length) {
                        let productsIds = [];
                        angular.forEach(task.consumable_asks, (consumable) => {
                            if (consumable.qty_remaining > 0) {
                                productsIds.push(consumable.product_id[0]);
                            }
                        });

                        // Get consumables from their id
                        let productsFilter = angular.copy($scope.filters.product_id);
                        swif.data.addFilter(productsFilter, 'id', 'in', productsIds);
                        swif.data.searchRead('product', productsFilter).then(function (products) {
                            if (!_.isEmpty(products)) {
                                angular.forEach(products.records, (product) => {
                                    $scope.onChangeFakeProduct(product);
                                })
                            }
                        });
                    }
                }
            });
        }

        $scope.duplicateMove = function (event, move) {
            if (!event.clientX && !event.clientY) {
                // Quick hack to prevent duplicate fonction from execute when pressing Enter key in barcode input
                // (because this is one of the button in the same form and... html magic you know...)
                return;
            }
            $scope.model.moves.push(angular.copy(move));
        }

        $scope.barcodeCallback = function (value) {
            if (!value) {
                return false;
            }


            // Select task with barcode if openstc module is installed
            if ($scope.modules.openstc) {
                var keyValue = value.split(' ');
                if (keyValue.length === 2 && keyValue[0] === 'task') {
                    const taskId = keyValue[1];
                    $scope.loadConsumablesForTask(taskId);
                }
            }
            var filter = angular.copy($scope.filters.product_id);
            swif.data.addFilter(filter, 'default_code', '=', value);
            swif.data.get('consumable', undefined, filter).then(function (data) {
                if (!_.isEmpty(data)) {
                    $scope.onChangeFakeProduct(data[0]);
                }
            });
            return true;
        };
        $scope.onRemoveLine = function (move) {
            service.removeMove($scope.model, move);
        };
        $scope.onChangeWarehouse = function (warehouse) {
            service.parseMoves($scope.model);
        };


        $scope.$watch('model.warehouse_id', function (newV, oldV) {
            if (newV && !angular.equals(newV,oldV)) {
                for (const move of $scope.model.moves)
                    move.warehouse_id = newV
            }
        });

        $scope.onChangeDepartment = function (department) {
            service.parseMoves($scope.model);
            $scope.filters = service.getFilters($scope.model);
        };
        $scope.onWarehouseLineChange = function (item, move) {
            move.warehouse_id = item
            service._computeQtyAvailable(false, move);
        };
    }

    ConsumableCatalogController.$inject = ['$scope', '$q', 'swifFrameworkService', 'ConsumableStockService'];
    function ConsumableCatalogController ($scope, $q, swif, service) {
        console.log('Init ConsumableCatalogController')
        function _parseCatalogLevel (categ, catalog, index) {
            // note: before recursive iterations, categ is the catalog itself
            index = index || 0;
            if (categ.isOpen) {
                _.forEach(categ.sub_categ, function (sub) {
                    sub.index = index;
                    catalog.items.push(sub);
                    _parseCatalogLevel(sub, catalog, index + 1);
                });
                _.forEach(categ.consumables, function (consumable) {
                    consumable.index = index;
                    catalog.items.push(consumable);
                });
            }
        }

        function parseCatalog (catalog) {
            catalog.items = [];
            _parseCatalogLevel(catalog, catalog);
        }

        function fetchCategories (parent_id) {
            var filter = {fields: ['name', 'parent_id']};
            filter.limit = 0;
            swif.data.addFilter(filter, 'parent_id', '=', parent_id || false);
            swif.data.sortOn(filter, 'name', 'ASC');
            return swif.data.get('consumable_category', undefined, filter);
        }

        function fetchConsumables (categ_id) {
            var filter = {fields: ['name', 'type_id', 'product_id']};

            if (categ_id) {
                swif.data.addFilter(filter, 'type_id', '=', categ_id);
            }

            var user = swif.user.getAuthenticatedUserData();
            if (_.includes(user.access_rights, 'ACHATS_CLAIMER') && !_.includes(user.access_rights, 'ACHATS_MANAGER')) {
                swif.data.addFilter(filter, 'type_id.service_ids', '=', user.service_id[0]);
            }

            swif.data.sortOn(filter, 'name', 'ASC');
            return swif.data.get('consumable_stock', undefined, filter);
        }

        function loadData (categ) {
            var ret = $q.defer();
            var defers = [];
            if (!categ.sub_categ) {
                // fetch children categories
                defers.push(fetchCategories(categ.id).then(function (data) {
                    categ.sub_categ = data;
                }));
            }
            if (!categ.consumables) {
                defers.push(fetchConsumables(categ.id).then(function (data) {
                    _.forEach(data, function (item) {
                        // set 'selected' to consumable already in cart
                        if (_.find($scope.consumablesInCart, {id: item.id})) {
                            item.selected = true;
                        }
                        // and extends the consumable cache (catalog.items is volatile)
                        // cache store references, used in preValidate
                        $scope.model.catalog.cache.push(item);
                    });
                    categ.consumables = data;
                }));
            }
            if (defers.length > 0) {
                ret = $q.all(defers);
            } else {
                ret.resolve();
                ret = ret.promise;
            }
            return ret.then(function () {
                parseCatalog($scope.model.catalog);
                return $scope.model.catalog;
            });
        }

        function initialize () {
            $scope.consumablesInCart = swif.cart.getCartItems('consumable_stock');
            $scope.model.catalog = {isOpen: true, cache: []};
            loadData($scope.model.catalog);
        }
        initialize();

        $scope.onClickCategory = function (categ) {
            // toggle isOpen attribute
            categ.isOpen = categ.isOpen ? false: true;
            loadData(categ);
        };
        $scope.onClickConsumable = function (consumable) {
            consumable.selected = consumable.selected ? false: true;
        };
    }

})();
